import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";

export function useRemoteDeleteFloorTimeframe({
  targetFloorInventoryId,
  start,
  end,
  fillGapStrategy
}: {
  targetFloorInventoryId: number;
  start: string;
  end: string | null;
  fillGapStrategy: "previous" | "next";
}) {
  const { t } = useTranslation();

  const params = end
    ? { targetFloorInventoryId, start, end, fillGapStrategy }
    : { targetFloorInventoryId, start, fillGapStrategy };

  return useRemoteMutation<void, RemoteApiError, any>({
    url: "plan/timeframe",
    key: ["delete", "version"],
    method: "delete",
    params,
    snackbarTextOnFail: t("Error deleting version")
  });
}
